'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a shown when the user navigates to a non-existent
 * page during assessment.
 *
 * @deprecated - Refer to using `DeviceError404Animation` instead.
 */

export function DeviceError404AnimationV2(props: IAnimationProps) {
  const loadAnimation = () => import('./raw-animation-data/404/404-error.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="DeviceError404AnimationV2"
    />
  );
}
